import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Typography from '@mui/material/Typography';
import { getSubscriptionHistory } from '../../../api/settings';
import ModalTemplate from '../../Decs/Modals/_ModalTemplate';

const SubscriptionHistoryModal = ({ isOpen, setIsOpen, companyId }) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const columns = [
    {
      field: 'lastUpdated',
      headerName: 'Last Updated',
      flex: 1,
      editable: false,
      headerClassName: 'table-header',
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 1,
      editable: false,
      headerClassName: 'table-header',
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      flex: 1,
      editable: false,
      headerClassName: 'table-header',
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'username',
      headerName: 'User',
      flex: 1,
      editable: false,
      headerClassName: 'table-header',
    },
  ];

  // Fetch subscription history when modal opens
  useEffect(() => {
    const fetchHistory = async () => {
      if (isOpen && companyId) {
        setLoading(true);
        setError('');
        try {
          const data = await getSubscriptionHistory(companyId);
          setHistoryData(data || []);
        } catch (err) {
          setError('Failed to load subscription history');
          console.error('Error fetching subscription history:', err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchHistory();
  }, [isOpen, companyId]);

  return (
    <ModalTemplate
      open={isOpen}
      onClose={() => setIsOpen(false)}
      title="Subscription History"
      body={
        <>
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <div style={{ height: 400, width: '100%', marginTop: 20 }}>
            <DataGridPro
              rows={historyData}
              columns={columns}
              loading={loading}
              density="compact"
              disableColumnFilter
              disableColumnMenu
              disableColumnPinning
              disableColumnReorder
              disableColumnResize
              disableColumnSelector
              disableColumnSorting
              disableDensitySelector
              disableRowSelectionOnClick
              disableMultipleRowSelection
              rowSelection={false}
              hideFooter
              sx={{ border: 0 }}
              getRowId={(row) => row.id || Math.random()}
            />
          </div>
        </>
      }
      buttons={[
        <Button key={0} onClick={() => setIsOpen(false)}>
          Close
        </Button>,
      ]}
    />
  );
};

export default SubscriptionHistoryModal;
